import React from 'react';
import styles from '../../../assets/styles/globals.scss';

const AddIcon = (props) => {
  let { 
    height, 
    width, 
    iconColor,
    outlineType,
  } = props;
    
  const plus = (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink" 
      width={ width ? (width + 'px') : '17px' } 
      height={ height ? (height + 'px') : '17px' }
      viewBox="0 0 16 16"
    >
      <defs>
          <path id="Iconoclast/AddIcon/a" d="M8.64 15.04H7.36v-6.4H.96V7.36h6.4V.96h1.28v6.4h6.4v1.28h-6.4z"/>
      </defs>
      <use fill={iconColor ? iconColor : styles.secondaryLabelFont} fillRule="nonzero" xlinkHref="#a"/>
    </svg>
  );

  //for return, outlineType should be 'outlined'
  const outlined = (
    <svg 
      width={ width ? (width + 'px') : '17px' } 
      height={ height ? (height + 'px') : '17px' } 
      viewBox="0 0 17 17" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="company-filter--copy-2" transform="translate(-186.000000, -302.000000)" fillRule="nonzero" fill={iconColor ? iconColor : styles.secondaryLabelFont}>
        <path d="M194.5,319 C189.8148,319 186,315.1852 186,310.5 C186,305.8148 189.8148,302 194.5,302 C199.1852,302 203,305.8148 203,310.5 C203,315.1852 199.1852,319 194.5,319 Z M194.5,302.68 C190.1888,302.68 186.68,306.1888 186.68,310.5 C186.68,314.8112 190.1888,318.32 194.5,318.32 C198.8112,318.32 202.32,314.8112 202.32,310.5 C202.32,306.1888 198.8112,302.68 194.5,302.68 Z M194.84,314.24 L194.16,314.24 L194.16,310.84 L190.76,310.84 L190.76,310.16 L194.16,310.16 L194.16,306.76 L194.84,306.76 L194.84,310.16 L198.24,310.16 L198.24,310.84 L194.84,310.84 L194.84,314.24 Z" id="Plus_Circle"></path>
      </g>
    </svg>
  );

  //for return, outlineType should be 'dashed'
  const dashed = (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <polygon id="add-path-1" points="8.64 15.04 7.36 15.04 7.36 8.64 0.96 8.64 0.96 7.36 7.36 7.36 7.36 0.96 8.64 0.96 8.64 7.36 15.04 7.36 15.04 8.64 8.64 8.64"></polygon>
          <circle id="add-path-3" cx="16" cy="16" r="16"></circle>
          <mask id="add-mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="32" height="32" fill="white">
              <use xlinkHref="#add-path-3"></use>
          </mask>
      </defs>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Group-20">
              <g id="Color/Library/Active" transform="translate(8.000000, 8.000000)">
                  <mask id="add-mask-2" fill="white">
                      <use xlinkHref="#add-path-1"></use>
                  </mask>
                  <use id="Mask" fill="#2C2C2C" fillRule="nonzero" xlinkHref="#add-path-1"></use>
                  <g id="Color/Library/AO" mask="url(#add-mask-2)" fill={iconColor ? iconColor : '#184E78'}>
                      <g transform="translate(-8.000000, -8.000000)" id="Rectangle-Copy-10">
                          <rect x="0" y="0" width="32" height="32"></rect>
                      </g>
                  </g>
              </g>
              <use id="Oval" stroke={iconColor ? iconColor : '#184E78'} mask="url(#add-mask-4)" strokeWidth="2" strokeDasharray="2" fillRule="nonzero" xlinkHref="#add-path-3"></use>
          </g>
      </g>
    </svg>
  );

  return (
    <div className="AddIcon">
      { outlineType == 'dashed' ? dashed : outlineType == 'outlined' ? outlined : plus }
    </div>
  );
};

export default AddIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/AddIcon/index.js